const article = {
    slug: "first_fetico_experience",
    category: "BRAND ENTRY",
    title: "初めてのFETICOをレンタル体験",
    listDescription:
      "FETICOを“身体を強調する服”だけで終わらせず、身体と視線の関係を設計する服として読み解くArchive Guide。",
    seo: {
      title:
        "FETICOとは？デザインの特徴・舟山瑛美の経歴とFETICOレンタル体験｜Enclopedia",
      description:
        "FETICOとはどのようなブランドなのか。デザイナー舟山瑛美の経歴、The Figure: Feminineというコンセプト、ボディコンシャス、カットアウト、ランジェリー構造、日本生産へのこだわりを独自に解説。EnclopediaでFETICO（フェティコ）をレンタルで体験",
      keyword:
        "FETICO,FETICOとは,フェティコ,フェティコとは,FETICO ブランド,FETICO デザイナー,舟山瑛美,FETICO デザイン,FETICO 特徴,FETICO レンタル,フェティコ レンタル,FETICO ジャンプスーツ,FETICO ビスチェ,FETICO デニム,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_fetico_experience",
    },
    hero: {
      label: "FIRST FETICO EXPERIENCE",
      number: "01 / ENTRY",
      titleLines: ["初めての", "FETICOをレンタル体験。"],
      body:
        "FETICOは、単に身体のラインを強調するブランドではありません。\nどこを見せ、どこを覆い、どのような輪郭で立つのか。\n服を通して、身体の見せ方を自分自身で選び直すブランドです。\n\nデザイナー舟山瑛美の経歴、服の構造、ランジェリーとの関係を読み解きながら、Enclopediaで体験できるFETICOのアーカイブへつなげます。",
      keywords: [
        "the figure: feminine",
        "body and gaze",
        "lingerie structure",
        "archive experience",
      ],
      visualLabel: "BODY / STRUCTURE / AUTONOMY",
      visualTitle: ["身体を変えるのではなく、", "身体の見え方を選び直す。"],
      image: "media/archive_fashion/archive_guide_fetico.png",
      imageAlt:
        "FETICOの身体表現とデザイン構造を読み解くアーカイブガイド画像",
      ctaLabel: "レンタルできるFETICOを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/FETICO%EF%BC%88%E3%83%95%E3%82%A7%E3%83%86%E3%82%A3%E3%82%B3%EF%BC%89/?number=23",
    },
    thesis: {
      text:
        "FETICOが設計しているのは、理想的な女性の身体ではありません。着る人が、自分の身体をどう見せるかを選び直すための境界線です。",
      keywords: ["body", "boundary", "autonomy"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "FETICOは、",
          "“ボディコンシャスな服”だけでは説明できない。",
        ],
        body:
          "FETICOはしばしば、“女性の身体を美しく見せるブランド”“上品でセンシュアルな服”と説明されます。\n\nそれ自体は間違いではありません。しかし、その説明だけでは、なぜブラ、コルセット、カットアウト、ハイウエスト、透ける素材が繰り返し現れるのかまでは見えてきません。\n\nEnclopediaでは、FETICOを身体の形を誇張するブランドではなく、身体に向けられる視線を、着る人の側から編集するブランドとして読み解きます。",
      },
      brandOverview: {
        label: "03 / BRAND AND DESIGNER",
        titleLines: [
          "女性性を飾るのではなく、",
          "身体と服の関係を設計する。",
        ],
        body:
          "FETICOは、デザイナー舟山瑛美によって2020年に設立されたウィメンズブランドです。\n\nコンセプトは“The Figure: Feminine”。女性の造形美を強調してきた古典的なスタイルを参照しながら、その美意識や身体観を現代の視点から再構築しています。\n\n重要なのは、過去の女性像をそのまま再現していないことです。コルセット、ブラ、ドレス、ハイウエストといった歴史的な造形を用いながら、身体を誰かの理想へ近づけるのではなく、着る人自身が身体の見せ方を選べる服へ変換しています。",
        knowledgeItems: [
          {
            title: "舟山瑛美の経歴。",
            text:
              "高校卒業後に渡英し、帰国後はエスモードジャポン東京校で服作りを学び、2010年に卒業。国内ブランド、衣装制作などを経て、2016年からChristian Dadaのウィメンズデザインを担当しました。ブランド休止後の2020年、FETICOを立ち上げています。",
          },
          {
            title: "デザイン画だけで完成しない服。",
            text:
              "FETICOでは、舟山瑛美のデザインをもとに、パタンナー高浜温子がトワルを制作し、実際の身体に乗せながら修正を重ねます。さらにスタイリストの視点もトワルチェックへ加わり、丈、重心、写真に映ったときの輪郭まで検証されます。",
          },
          {
            title: "身体に沿うことを、モードとして扱う。",
            text:
              "舟山は、Vivienne Westwood、Alaïa、Alexander McQueenなど、身体にフィットする造形をモードとして提示したデザイナーからの影響を語っています。FETICOのフィットは、身体を小さく整えるためではなく、身体の存在感を服の中心へ戻すためのものです。",
          },
          {
            title: "未来のヴィンテージを作る。",
            text:
              "オリジナル素材や別注素材を用い、日本各地の繊維産地や職人と生産することもFETICOの核です。尾州のウール、新潟のニット、京都の織物など、身体へ触れる繊細さと、時間が経っても残る造形を両立させています。",
          },
        ],
      },
      lineGuide: {
        label: "04 / DESIGN LANGUAGE",
        titleLines: [
          "FETICOを特徴づけるのは、",
          "露出の多さではなく、境界線の置き方。",
        ],
        items: [
          {
            tag: "DESIGN CODE 01",
            title: "カットアウトは、身体を見せるための窓。",
            text:
              "FETICOのカットアウトは、単に布を減らした装飾ではありません。胸元、脇腹、腰、背中など、通常は意識されにくい部分へ開口部を置き、身体の見え方を限定的に切り取ります。露出の量ではなく、どこを見せるかがデザインされています。",
          },
          {
            tag: "DESIGN CODE 02",
            title: "下着を、服の内部から構造へ移す。",
            text:
              "ブラカップ、ボディスーツ、コルセット、ガーターベルトを思わせる線。本来は服の内側で身体を支えていたランジェリーの構造を、FETICOは外側へ露出させます。下着を見せるのではなく、服を成立させる骨格として再配置しています。",
          },
          {
            tag: "DESIGN CODE 03",
            title: "ニットと伸縮性が、身体との交渉を生む。",
            text:
              "リブ、シアーニット、ストレッチデニムなど、FETICOでは伸縮する素材が繰り返し使われます。硬い型へ身体を押し込むのではなく、服が身体に反応する余地を残すことで、異なる体型の上でも輪郭が立ち上がります。",
          },
          {
            tag: "DESIGN CODE 04",
            title: "相反するものを、一着の中で共存させる。",
            text:
              "硬いレザーと柔らかなチュール。肌を覆うハイネックと胸元の透け。古典的なドレスと工業的なファスナー。FETICOの女性像は、可憐か強いか、隠すか見せるかという二択ではなく、その両方を同時に引き受けます。",
          },
        ],
      },
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["実際に着ると、", "FETICOの何が見えてくるのか。"],
        intro:
          "FETICOは、ハンガーに掛かった状態と、身体に乗った状態で意味が大きく変わる服です。寸法だけでは把握しにくい、身体と服の接点を体験することが重要です。",
        items: [
          {
            index: "01",
            title: "身体の形より、線の位置が印象を変える",
            text:
              "ハイウエストの位置、ブラカップの高さ、切替線の角度、パンツの丈。FETICOでは数センチの違いが、胴の長さや脚の見え方、全身の重心を変えます。着ることで、身体そのものではなく、服の線が輪郭を作っていることが分かります。",
          },
          {
            index: "02",
            title: "肌が、“露出”から構成要素へ変わる",
            text:
              "カットアウトや透ける素材を身体に重ねると、見えている肌が服の外側ではなく、色や素材と並ぶデザインの一部として現れます。どこまで見せるかは、インナーやレイヤードによって着る人自身が調整できます。",
          },
          {
            index: "03",
            title: "服に身体を合わせる感覚が変わる",
            text:
              "身体の欠点を隠すために服を選ぶのではなく、自分が見せたい部分を起点に服を選ぶ。FETICOを着る体験は、似合うかどうかだけではなく、自分の身体をどう扱いたいかを考える時間になります。",
          },
        ],
      },
      quote: {
        textLines: [
          "身体を見せる服ではない。",
          "身体の見せ方を、自分で決めるための服。",
        ],
      },
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: ["FETICOは、", "着ることで完成する。"],
        items: [
          {
            number: "01",
            title: "サイズ表だけでは、相性を判断できない",
            text:
              "同じウエスト寸法でも、ブラ位置、股上、伸縮性、カットアウトの位置によって見え方は変わります。実際に身体へ乗せることで、自分にとって心地よいフィットかを確かめられます。",
          },
          {
            number: "02",
            title: "肌の見え方は、動いて初めて分かる",
            text:
              "立っているときと、座る、歩く、腕を上げるときでは、透けや開口部の見え方が異なります。静止した商品写真だけでは分からない距離感を、レンタル期間中に確認できます。",
          },
          {
            number: "03",
            title: "特別な服を、日常へ翻訳できる",
            text:
              "ビスチェをシャツに重ねる。ジャンプスーツからブラ部分を外す。ボディスーツをジャケットの内側に使う。FETICOはスタイリングによって露出と緊張感を調整できるため、自分の日常への取り入れ方を試せます。",
          },
        ],
      },
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるFETICO。"],
        body:
          "FETICOのアーカイブは、商品カテゴリーではなく、服が身体へどのように作用するかという視点から選びます。\n\nブラとパンツを一体化するジャンプスーツ、ランジェリーの線を外側へ移すビスチェ、日常着のデニムを身体の輪郭から再設計したハイライズパンツ。それぞれ異なる入口から、FETICOの身体観を体験できます。",
        items: [
          {
            meta: "FETICO / 2022SS",
            title: "COMBINED ORGANZA 2WAY BRA JUMPSUITS",
            text:
              "ブラとハイウエストパンツを一続きの構造へ変換した、FETICO初期を象徴するジャンプスーツ。ブラ部分を取り外すことで、ワイドパンツとしても着用できます。ランジェリーとテーラリングの境界を体験できる一着です。",
            href:
              "https://www.enclopedia-official.com/product/03920069-b874-495f-8ab9-58585f163be3",
            image:
              "media/product/REPLACE_03920069-b874-495f-8ab9-58585f163be3.jpg",
          },
          {
            meta: "FETICO / 2024AW",
            title: "FAUX LEATHER BUSTIER",
            text:
              "身体を内側から補整するビスチェを、スタイリングの最も外側へ移したアイテム。ブラウスやカットソーに重ねることで、露出を抑えながらFETICOの構造的な女性像を体験できます。",
            href:
              "https://www.enclopedia-official.com/product/4d2646e4-aea5-45ab-9533-1813e96e76a7",
            image:
              "media/product/REPLACE_4d2646e4-aea5-45ab-9533-1813e96e76a7.jpg",
          },
          {
            meta: "FETICO / 2023AW",
            title: "WASHED HIGH-RISE STRAIGHT JEANS",
            text:
              "FETICOの身体観を、日常的なデニムから体験できる一本。高いウエスト位置と縦に落ちるストレートラインによって、脚を細く見せるだけではなく、上半身と下半身の比率そのものを組み替えます。",
            href:
              "https://www.enclopedia-official.com/product/6f4c73c7-aa1d-47ac-8b48-369be335914e",
            image:
              "media/product/REPLACE_6f4c73c7-aa1d-47ac-8b48-369be335914e.jpg",
          },
        ],
      },
      faq: {
        label: "08 / FAQ",
        titleLines: ["FETICOを初めて着る人が、", "気になりやすいこと。"],
        items: [
          {
            question: "身体のラインに自信がなくても着られますか？",
            answer:
              "FETICOは、特定の体型だけを前提としたブランドではありません。伸縮性のあるニットやデニム、調整可能なストラップなど、身体へ反応する設計も多くあります。ただしアイテムごとにフィット感が大きく異なるため、商品寸法を確認したうえでレンタルすることが重要です。",
          },
          {
            question: "肌の露出が多すぎないか不安です。",
            answer:
              "シャツやシアートップスの上にビスチェを重ねる、ジャケットの内側にボディスーツを使うなど、レイヤードによって肌の見える範囲を調整できます。ランウェイと同じ着方を再現する必要はありません。",
          },
          {
            question: "最初の一着は、何がおすすめですか？",
            answer:
              "日常に取り入れやすい入口なら、ハイライズデニムがおすすめです。FETICOらしいランジェリー構造を試すならビスチェ、ブランドの身体観を一着で強く体験するならブラ付きジャンプスーツが適しています。",
          },
          {
            question: "オケージョン以外でも着られますか？",
            answer:
              "着られます。FETICOはドレスやボディスーツの印象が強い一方で、デニム、ジャケット、ニットなど日常着に近いアイテムも展開しています。露出や装飾をレイヤードで調整することで、普段のワードローブへ組み込めます。",
          },
          {
            question: "レンタル後に購入できますか？",
            answer:
              "購入対象となっているアイテムは、レンタル期間中に購入へ進めます。購入の可否や金額については、各商品ページとレンタル後の案内をご確認ください。",
          },
        ],
      },
      finalCta: {
        titleLines: ["FETICOの身体観を、", "実際に着て確かめる。"],
        body:
          "FETICOのカットアウト、ブラ構造、ハイウエストは、写真の中だけで完成するデザインではありません。\n\n自分の身体に重ね、歩き、座り、日常の服と組み合わせたとき、初めてその意味が立ち上がります。\nEnclopediaで、FETICOが作る新しい身体の輪郭を体験してください。",
        buttonLabel: "レンタルできるFETICOを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/FETICO%EF%BC%88%E3%83%95%E3%82%A7%E3%83%86%E3%82%A3%E3%82%B3%EF%BC%89/?number=23",
      },
    },
  };
  
  export default article;